module.exports = __webpack_public_path__ + "assets/images/boundaries/comparison/2015/mobile_old.svg?v=551ef830";